module.exports = __webpack_public_path__ + "cdeeeb0f7743cb6a7fb1147f14e5846a.MP3";